package com.fireavert.administration.super_admin_tools_page.data_models.data_model

import kotlinx.serialization.Serializable

@Serializable
data class SmokeAlarmDurationRecordModel(
    val propertyId: Int,
    val propertyName: String,
    val unitNumber: String,
    val deviceName: String,
    val durationMinutes: Double,
    val startTime: String,
    val endTime: String
)